import React from 'react';
import { useSelector } from 'react-redux';
import { Outlet, useLocation } from 'react-router-dom';
import Sidebar from './Sidebar';
import GlobalHeader from './GlobalHeader';
import { vehicleGroupService } from '../Services/vehicle.group.service';
import { useState, useEffect } from 'react';
import { Footer } from './Footer';

export default function NewLayout() {
  const { pageTitle } = useSelector(
    (rootReducer) => rootReducer.layoutDataReducer
  );
  const location = useLocation();
  const [optionVehicles, setOptionVehicles] = useState([]);

  // Verificar se é a página Home para mostrar filtros
  const isHomePage = location.pathname === '/home' || location.pathname === '/';

  useEffect(() => {
    if (isHomePage) {
      const fetchVehicleGroups = async () => {
        try {
          const responseGroups = await vehicleGroupService.fetchGroups();
          if (responseGroups) {
            // Mapear para o formato esperado pelo filtro
            const mappedGroups = responseGroups.map(group => ({
              groupVehicleId: group.vehicleGroupId,
              groupVehicleName: group.vehicleGroupName
            }));
            setOptionVehicles(mappedGroups);
          }
        } catch (err) {
          console.error("Erro ao buscar grupos de veículos:", err);
        }
      };
      fetchVehicleGroups();
    }
  }, [isHomePage]);

  return (
    <div className="movyx-layout">
      {/* Sidebar */}
      <Sidebar />
      
      {/* Main Content */}
      <div className="movyx-main">
        {/* Global Header */}
        <div className="movyx-navbar">
          <GlobalHeader 
            showFilters={isHomePage} 
            optionVehicles={optionVehicles}
          />
        </div>
                
        {/* Page Content */}
        <div className="movyx-content">
          <Outlet />
        </div>
        {/* <Footer /> */}

      </div>
    </div>
  );
}